import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown} from '@homeaway/react-dropdown';

import './Birdhouse.less';

export class Birdhouse extends React.Component {
    static propTypes = {
        withoutLink: PropTypes.bool,
    };

    constructor(props) {
        super(props);
    }

    taglineMarkup = {
        __html: this.props.tagline,
    };

    render() {
        if (this.props.isMobile) {
            if (this.props.withoutLink) {
                return (
                    <img alt={this.props.altText} className="site-header-birdhouse__image" role="presentation" src={this.props.image} />
                );
            }

            return (
                <a className={this.className} href="/" title={this.props.text}>
                    {/* HOMEPAGE-783 "epHpVrboHeaderColor" A/B test uses a white background, so we need to use different logo image. */}
                    <img alt={this.props.altText} className="site-header-birdhouse__image" role="presentation" src={this.props.image} />
                </a>
            );
        }

        const toggle = (
            <button className="site-header-birdhouse__toggle"
                tabIndex={0}
            >
                {/* HOMEPAGE-783 "epHpVrboHeaderColor" A/B test uses a white background, so we need to use different logo image. */}
                <img alt={this.props.altText} className="site-header-birdhouse__image" role="presentation" src={this.props.image} />
                {/* eslint-disable-next-line react/no-danger */}
                <div className="site-header-birdhouse__tagline" dangerouslySetInnerHTML={this.taglineMarkup} />
            </button>
        );

        return (
            <Dropdown className="site-header-birdhouse" customToggle={toggle} dropdownRight id="site-header__birdhouse"label={this.props.tagline} >
                <div className="site-header-birdhouse__dropdown-menu">
                    <p>{this.props.description}</p>
                    {!this.props.withoutLink && (
                        <div>
                            <a href={this.props.link}>{this.props.text}</a>
                        </div>
                    )}
                    <div className="text-right site-about-logo-wrapper">
                        <img alt="logo" src="//csvcus.homeaway.com/rsrcs/cdn-logos/1.5.1/bce/brand/homeaway/logo-simple.svg" />
                    </div>
                </div>
            </Dropdown>
        );
    }
}
